import { PageResp } from 'src/app/core/models/page/page-response';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AutoPrintSettingGetHeaderRequest } from '../pages/auto-print-setting/interface/auto-print-setting-get-header-request';
import { AutoPrintSettingTableHeaderData } from '../pages/auto-print-setting/interface/auto-print-setting-header-data';
import { AutoPrintSettingGetDetailRequest } from '../pages/auto-print-setting/interface/auto-print-setting-get-detail-request';
import { AutoPrintSettingTableDetailData } from '../pages/auto-print-setting/interface/auto-print-setting-detail-data';
import { UpdateAutoPrintSettingDetailRequest } from '../pages/auto-print-setting/interface/update-auto-print-setting-detail-request';
import { CreateAutoPrintSettingDetailRequest } from '../pages/auto-print-setting/interface/create-auto-print-setting-detail-request';
import { UpdateAutoPrintSettingHeaderRequest } from '../pages/auto-print-setting/interface/update-auto-print-setting-header-request';
import { CreateAutoPrintSettingHeaderRequest } from '../pages/auto-print-setting/interface/create-auto-print-setting-header-request';

@Injectable({
  providedIn: 'root'
})
export class AutoPrintSettingService {

  private baseUrl: string = `${environment.logisticsApiUrl}/documentAutoPrintSetting`;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }

  constructor(private http: HttpClient) { }

  getAutoPrintSettingHeader(request: AutoPrintSettingGetHeaderRequest): Observable<PageResp<AutoPrintSettingTableHeaderData>> {
    const url = this.baseUrl + '/getAutoPrintSettingHeader';
    return this.http.post<PageResp<AutoPrintSettingTableHeaderData>>(url, request, this.httpOptions);
  }

  saveAutoPrintSettingHeader(request: any): Observable<void> {
    const url = this.baseUrl + '/saveAutoPrintSettingHeader';
    return this.http.post<void>(url, request, this.httpOptions);
  }

  deleteAutoPrintSettingHeader(seqNo: Number): Observable<any>{
    const url = this.baseUrl + `/deleteAutoPrintSettingHeader/${seqNo}`;
    return this.http.delete(url);
  }

  getAutoPrintSettingDetail(request: AutoPrintSettingGetDetailRequest): Observable<PageResp<AutoPrintSettingTableDetailData>> {
    const url = this.baseUrl + '/getAutoPrintSettingDetail';
    return this.http.post<PageResp<AutoPrintSettingTableDetailData>>(url, request, this.httpOptions);
  }

  getAutoPrintSettingDocTypeOption(): Observable<any> {
    const url = this.baseUrl + '/getAutoPrintSettingDocTypeOption';
    return this.http.get(url);
  }

  // updateAutoPrintSettingDetail(request: UpdateAutoPrintSettingDetailRequest): Observable<void> {
  //   const url = this.baseUrl + '/updateAutoPrintSettingDetail';
  //   return this.http.post<void>(url, request, this.httpOptions);
  // }

  // createAutoPrintSettingDetail(request: CreateAutoPrintSettingDetailRequest): Observable<void> {
  //   const url = this.baseUrl + '/createAutoPrintSettingDetail';
  //   return this.http.post<void>(url, request, this.httpOptions);
  // }

  saveAutoPrintSettingDetail(request: any): Observable<void> {
    const url = this.baseUrl + '/saveAutoPrintSettingDetail';
    return this.http.post<void>(url, request, this.httpOptions);
  }

  exportAutoPrintSettingDetail(request: AutoPrintSettingGetDetailRequest): Observable<any> {
    const url = this.baseUrl + '/exportAutoPrintSettingDetail';
    return this.http.post(url, request, { responseType: 'blob'});
  }

  deleteAutoPrintSettingDetail(seqNo: Number): Observable<any>{
    const url = this.baseUrl + `/deleteAutoPrintSettingDetail/${seqNo}`;
    return this.http.delete(url);
  }

}
